import styled from '@emotion/styled';
import { FC } from 'react';

type Props = {
  className?: string;
};

const Footer: FC<Props> = ({ className, children }) => {
  return <Root className={className}>{children}</Root>;
};

const Root = styled('div')(`
  width: 100%; 
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 16px 24px;
  text-align: end;
  background-color:#F5F6F7;
  border-top: solid 1px rgba(230, 231, 232, 1);
`);

export default Footer;
